<button (click)="onClick()">
  <img src="/assets/icons/timezone.svg" class="input-img" />
  <span>{{ selectedTimeZoneDisplay }}</span>
</button>
